/**
 * Authenticated axios instance for staff portal.
 * Token stored in sessionStorage (cleared on tab close, not accessible cross-tab).
 */
import axios from "axios";

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Key used for session storage
const TOKEN_KEY = "xs_token";

export const getToken  = () => sessionStorage.getItem(TOKEN_KEY) || localStorage.getItem(TOKEN_KEY);
export const setToken  = (t) => { sessionStorage.setItem(TOKEN_KEY, t); localStorage.removeItem(TOKEN_KEY); };
export const clearToken= () => { sessionStorage.removeItem(TOKEN_KEY); localStorage.removeItem(TOKEN_KEY); };

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      clearToken();
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export default api;
